import React from 'react';
import { Button, Tooltip } from 'antd';
import { Upload } from 'lucide-react';
import { useAtomValue } from 'jotai';
import {
  hasRecordedScenesForExportAtom,
  isDadanExportInProgressAtom,
  canStartDadanExportAtom,
} from '../../atoms/exportAtoms';
import ExportPopover from './ExportPopover';
import './export.scss';

interface ExportButtonProps {
  isBlankMode?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({ isBlankMode = false }) => {
  const hasRecordedScenes = useAtomValue(hasRecordedScenesForExportAtom);
  const isInProgress = useAtomValue(isDadanExportInProgressAtom);
  const canExport = useAtomValue(canStartDadanExportAtom);

  if (isBlankMode) {
    return null;
  }

  const getTooltipText = () => {
    if (isInProgress) {
      return 'Export in progress...';
    }
    if (!hasRecordedScenes) {
      return 'Record at least one scene to export';
    }
    return 'Export video to your personal library';
  };

  return (
    <ExportPopover>
      <Tooltip 
        title={getTooltipText()} 
        placement="bottom"
        styles={{ root: { textAlign: 'center' }, body: { textAlign: 'center' } }}
      >
        <Button
          className={`export-button ${isInProgress ? 'export-button--loading' : ''}`}
          type="primary"
          icon={<Upload size={16} />}
          disabled={!canExport && !isInProgress}
          loading={isInProgress}
        >
          Export
        </Button>
      </Tooltip>
    </ExportPopover>
  );
};

export default ExportButton;
